export const CANCEL_SUBSCRIPTION_ATTEMPT = 'CANCEL_SUBSCRIPTION_ATTEMPT';
export const CANCEL_SUBSCRIPTION_FAILURE = 'CANCEL_SUBSCRIPTION_FAILURE';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';
export const CANCEL_SUBSCRIPTION_CLEAR = 'CANCEL_SUBSCRIPTION_CLEAR';
export const CLEAR_STATE = 'CLEAR_STATE';
